import { BASE_CONFIG } from '@/config'

const CN_CHAR = /[一-龥]/
const parser = typeof DOMParser !== 'undefined' ? new DOMParser() : null

/**
 * 按分数取题面着色。阈值与以前一致：优秀线（默认 80）以上绿、及格线（默认 60）以上黄，
 * 有分但不及格红，0 分 / 漏读灰。
 */
export function colorForScore(score) {
  const s = Number(score)
  if (!Number.isFinite(s) || s <= 0) return '#838996'
  if (s > BASE_CONFIG.excellent_score) return '#09cba0'
  if (s > BASE_CONFIG.standard_score) return '#f9b718'
  return '#eb5564'
}

/**
 * 把厂商的逐字结果套到题面上。
 *
 * screen_text 每一项的 content 是 `<span><font color="black">四</font>…</span>` 这种逐字标记，
 * 标点带 `ignore="true"`。厂商返回的逐字结果只覆盖汉字（多读的字标 Insertion，不在题面里，
 * 要先剔掉），两边按汉字顺序一一对应，给每个 font 写上颜色。
 *
 * @param {Array<{content: string}>} screenText 题目的 screen_text
 * @param {Array<{text: string, score: number, errorType?: string}>} words 归一化逐字结果
 * @returns {string[]} 与 screenText 等长，每项是着色后的 content（没有 font 标记的原样返回）
 */
export function colorScreenText(screenText, words) {
  const items = Array.isArray(screenText) ? screenText : []
  if (!parser) return items.map((item) => (item && item.content) || '')

  // 展开成"一个汉字一条"：Azure 按音节已经是逐字，SpeechSuper 句子核的一条可能是多字词，
  // 不展开的话后面所有字整体错位
  const results = []
  for (const w of words || []) {
    if (!w || w.errorType === 'Insertion') continue
    const n = String(w.text || '').replace(/[^一-龥]/g, '').length || 1
    for (let k = 0; k < n; k++) results.push(w)
  }
  let cursor = 0

  return items.map((item) => {
    const content = (item && item.content) || ''
    if (!content || content.indexOf('<font') < 0) return content

    const doc = parser.parseFromString(content, 'text/xml')
    if (doc.getElementsByTagName('parsererror').length) return content
    const fonts = doc.getElementsByTagName('font')
    for (let i = 0; i < fonts.length; i++) {
      const font = fonts[i]
      const text = font.textContent || ''
      if (font.getAttribute('ignore') === 'true' || !CN_CHAR.test(text)) continue

      // 一个 font 通常是一个汉字；万一是多字词，就取这几个字的平均分
      const count = text.replace(/[^一-龥]/g, '').length || 1
      let sum = 0
      let n = 0
      for (let k = 0; k < count && cursor < results.length; k++, cursor++) {
        sum += Number(results[cursor].score) || 0
        n++
      }
      font.setAttribute('color', n ? colorForScore(sum / n) : '#838996')
    }
    return new XMLSerializer().serializeToString(doc)
  })
}
